import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { MerchandisingCollection } from '@/services/MerchandisingCollectionsService';

interface HeaderProps {
  collection: Pick<MerchandisingCollection, 'name' | 'description'>;
}

export function Header({ collection }: HeaderProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.MerchandisingCollections.pages.Collection.components.Header',
  });

  return (
    <div className="flex items-center space-x-4">
      <Link to={ROUTE_PATHS.MERCHANDISING_COLLECTIONS}>
        <Button variant="outline" size="sm">
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('backButtonLabel')}
        </Button>
      </Link>

      <div className="flex-1">
        <h1 className="text-3xl font-bold tracking-tight">{collection.name}</h1>
        <p className="text-muted-foreground">{collection.description}</p>
      </div>
    </div>
  );
}
